module.exports = "/_next/static/media/403370818e70120585f7f71dcd420c4c.svg";